// KITEIQ — IKO certification catalogue (self-reported; no IKO API).
// Official IKO certification names are kept in English (proper nouns); the
// surrounding UI copy + group headers are localised via i18n keys iko.groups.*

export const IKO_GROUPS = [
  {
    key: 'rider',
    certs: [
      { id: 'discovery_l1', name: 'Discovery Kiteboarder · Level 1' },
      { id: 'intermediate_l2', name: 'Intermediate Kiteboarder · Level 2' },
      { id: 'independent_l3', name: 'Independent Kiteboarder · Level 3' },
      { id: 'advanced_l4', name: 'Advanced Kiteboarder · Level 4' },
    ],
  },
  {
    key: 'evolution',
    certs: [
      { id: 'evo_freeride_l5', name: 'Evolution Freeride · Level 5' },
      { id: 'evo_freestyle_l5', name: 'Evolution Freestyle · Level 5' },
      { id: 'evo_wave_l5', name: 'Evolution Wave Riding · Level 5' },
      { id: 'evo_hydrofoil_l5', name: 'Evolution Hydrofoil · Level 5' },
      { id: 'evo_wingfoil_l5', name: 'Evolution Wing Foil · Level 5' },
    ],
  },
  {
    key: 'pro',
    certs: [
      { id: 'assistant', name: 'Assistant Instructor' },
      { id: 'instructor_l1', name: 'Instructor · Level 1' },
      { id: 'instructor_l2', name: 'Instructor · Level 2' },
      { id: 'instructor_l3', name: 'Instructor · Level 3' },
      { id: 'coach_l1', name: 'Coach · Level 1' },
      { id: 'coach_l2', name: 'Coach · Level 2' },
      { id: 'wingfoil_instructor', name: 'Wingfoil Instructor' },
      { id: 'assistant_trainer', name: 'Assistant Trainer' },
      { id: 'coach_trainer', name: 'Coach Trainer' },
      { id: 'examiner', name: 'Examiner' },
    ],
  },
];

// Flat id -> name lookup
export const IKO_CERT_NAMES = IKO_GROUPS.reduce((acc, g) => {
  g.certs.forEach((c) => { acc[c.id] = c.name; });
  return acc;
}, {});

export const ikoCertName = (id) => IKO_CERT_NAMES[id] || id;

// Years for the "obtained in" select (current year down to 1998)
export const ikoYears = () => {
  const now = new Date().getFullYear();
  const out = [];
  for (let y = now; y >= 1998; y -= 1) out.push(y);
  return out;
};

export const MONTH_KEYS = [
  'jan', 'feb', 'mar', 'apr', 'may', 'jun',
  'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
];
